import dayjs from "dayjs";

// Import all supported locales
import "dayjs/locale/en";
import "dayjs/locale/en-gb";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import "dayjs/locale/vi";
import "dayjs/locale/es";
import "dayjs/locale/de";
import "dayjs/locale/ko";
import "dayjs/locale/fr";
import "dayjs/locale/pt";
import "dayjs/locale/pt-br";
import "dayjs/locale/pl";
import "dayjs/locale/nl";

// Import plugins
import localizedFormat from "dayjs/plugin/localizedFormat";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import { locales } from "./i18n/config";

// Extend dayjs with plugins
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(utc);

// Make all locales start the week on Monday
locales.forEach((lang) => {
  dayjs.updateLocale(lang, { weekStart: 1 });
});

export default dayjs;
